import MaskBehaviors from './masks-behaviors'

$( window ).on( "load", function () {
  window.initInputMasks();
});

window.initInputMasks = function() {
  $('.cep').mask('00.000-000');
  $('.ncm-mask').mask('0000.00.00');
  $('#cnpj').mask('00.000.000/0000-00');
  $('.cnpj-mask').mask('00.000.000/0000-00');
  $('.cellphone-mask').mask(MaskBehaviors.nineDigitsBehavior, MaskBehaviors.nineDigitsOptions);
  $('.phone-mask').mask(MaskBehaviors.nineDigitsBehavior, MaskBehaviors.nineDigitsOptions);
  $('.money').mask("#.##0,00", {placeholder: '0,00', reverse: true});
  $('.mask-integer').mask('0#');
  $('.integer-with-limit').mask('0000000000');
  $('.product-package').mask('#0,000', {reverse: true});
  $('.unit-mask').mask('#0.00', {reverse: true});
  $('.month-year').mask('99/9999', {placeholder: '__/____', clearIfNotMatch: true});
  $('.date-mask').mask('99/99/9999', {placeholder: '__/__/____', clearIfNotMatch: true});
  $('.datetime-mask').mask('99/99/9999 99:99', {placeholder: '__/__/____ 00:00', clearIfNotMatch: true});

  $(".cnpj-cpf-mask").mask("00.000.000/0000-00", {
    onKeyPress: function(cpfcnpj, e, field, options) {
      const masks = ["000.000.000-000", "00.000.00000/000", "00.000.000/0000-00"];
      let mask = null;
      if (cpfcnpj.length <= 14) {
        mask = masks[0];
      } else if (cpfcnpj.length <= 15) {
        mask = masks[1];
      } else {
        mask = masks[2];
      }
      $(".cnpj-cpf-mask").mask(mask, options);
    },
    onpaste:function(cpfcnpj, e, field, options) {
      const masks = ["000.000.000-000", "00.000.00000/000", "00.000.000/0000-00"];
      let mask = null;
      if (cpfcnpj.length <= 14) {
        mask = masks[0];
      } else if (cpfcnpj.length <= 15) {
        mask = masks[1];
      } else {
        mask = masks[2];
      }
      $(".cnpj-cpf-mask").mask(mask, options);
    }
  });

}



// WEBPACK FOOTER //
// ./resources/assets/js/commons/masks.js